import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiTabs from '@material-ui/core/Tabs';
import { combineProps, styled, useThemeProps, } from '../../../foundation';
import { MoreMenuTabs } from './MoreMenuTabs';
import { TabsStyle } from './styles';
import { RcTabsClasses } from './utils';
var _RcTabs = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTabs' });
    var classesProp = props.classes, childrenProp = props.children, variantProp = props.variant, size = props.size, resizeThrottleTime = props.resizeThrottleTime, MoreButtonProps = props.MoreButtonProps, rest = __rest(props, ["classes", "children", "variant", "size", "resizeThrottleTime", "MoreButtonProps"]);
    var isMore = variantProp === 'moreMenu';
    var classes = useMemo(function () { return combineProps(RcTabsClasses, classesProp); }, [classesProp]);
    var children = useMemo(function () {
        return React.Children.map(childrenProp, function (child) {
            return React.cloneElement(child, { size: size });
        });
    }, [childrenProp, size]);
    if (isMore) {
        return (React.createElement(MoreMenuTabs, __assign({}, rest, { resizeThrottleTime: resizeThrottleTime, ref: ref, classes: classes, size: size, MoreButtonProps: MoreButtonProps }), children));
    }
    return (React.createElement(MuiTabs, __assign({}, rest, { ref: ref, classes: classes, variant: isMore ? 'standard' : variantProp, indicatorColor: "primary", textColor: "primary" }), children));
});
var RcTabs = styled(_RcTabs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TabsStyle);
RcTabs.defaultProps = {
    variant: 'standard',
    size: 'small',
};
RcTabs.displayName = 'RcTabs';
export { RcTabs };
var templateObject_1;
